import type { IconSvgObject } from './types';

const FoldVerticalIcon: IconSvgObject = [
  ["path", { d: "M15 19L12 16L9 19M12 17L12 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 5L12 8L9 5M12 7L12 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 12L20 12M16 12L14 12M10 12L8 12M4 12L2 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FoldVerticalIcon;
